import { cva, type VariantProps } from "class-variance-authority";
import type { ButtonHTMLAttributes, Ref } from "react";

import { cn } from "./cn.js";

export const buttonVariants = cva(
  "inline-flex shrink-0 items-center justify-center gap-2 rounded-sm border text-sm font-semibold transition-colors disabled:pointer-events-none disabled:opacity-45 [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        primary:
          "border-transparent bg-accent text-accent-ink hover:bg-accent-dim",
        secondary:
          "border-border-hi bg-surface text-ink hover:border-accent-line hover:bg-surface-hi",
        ghost:
          "border-transparent bg-transparent text-ink-2 hover:bg-surface-hi hover:text-ink",
        outline:
          "border-border-hi bg-transparent text-ink-2 hover:border-accent-line hover:text-ink",
      },
      size: {
        default: "min-h-11 px-4 py-2.5",
        small: "min-h-9 px-3 py-1.5 text-xs",
        icon: "size-11 p-0",
        "icon-small": "size-9 p-0",
      },
    },
    defaultVariants: { variant: "primary", size: "default" },
  },
);

export interface ButtonProps
  extends
    ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  ref?: Ref<HTMLButtonElement>;
}

export function Button({
  className,
  size,
  type = "button",
  variant,
  ...props
}: ButtonProps) {
  return (
    <button
      className={cn(buttonVariants({ size, variant }), className)}
      type={type}
      {...props}
    />
  );
}
